














import Vue from 'vue'
import { Route, NavigationGuardNext } from 'vue-router'

import HomePage from './template'

import { LookupSVGFile, GetSVGFile } from '@/api/svg'

export default Vue.extend({
  name: 'SvgPage',
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
    // eslint-disable-next-line
    next((vm: Vue) => {
      // TODO: add handler to fetch data before route enter
    })
  },
  beforeRouteUpdate(to: Route, from: Route, next: NavigationGuardNext<Vue>) {
    // eslint-disable-next-line
    next((vm: Vue) => {
      // TODO: add handler to fetch data before route enter
    })
  },

  data() {
    return {
      error: false,
      errorMessage: '',
      templateVisible: false,
      svgTemplate: HomePage,
    }
  },
  methods: {
    async getPage() {
      try {
        const info = await LookupSVGFile(this.$route.params.uid)
        this.error = false
        this.errorMessage = ''

        if (info.redirect) {
          return this.$router.push({
            params: { uid: info.uid, slug: info.slug },
          })
        }

        if (
          this.$route.query &&
          this.$route.query.stack == undefined &&
          info.defaultStacks != ''
        ) {
          this.$router.replace({
            path: this.$route.path,
            query: { stack: info.defaultStacks.split(',') },
          })
        }

        let data = await GetSVGFile(info.uid, info.slug)
        data = (data as string).replace(/click="/g, '@click="')

        // eslint-disable-next-line
        // ;(this.svgTemplate as any) = undefined
        this.svgTemplate = HomePage.extend({
          name: 'SvgForCEMS',
          template: `<div style="max-height:100%; max-width:100%; height:100%;" id="svg_component">${data}</div>`,
        })
        this.templateVisible = true
        return
        // eslint-disable-next-line
      } catch (err) {
        if (err.data != undefined && err.data.message != undefined) {
          this.errorMessage = err.data.message
        } else {
          this.errorMessage = err
        }

        this.templateVisible = false
        this.error = true
      }
    },
  },
  watch: {
    '$route.params.uid': function() {
      this.getPage()
    },
  },

  created() {
    this.getPage()
  },
})
